import { render, staticRenderFns } from "./ResultFooter.vue?vue&type=template&id=3ea3ef31&scoped=true&"
import script from "./ResultFooter.vue?vue&type=script&lang=ts&"
export * from "./ResultFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ResultFooter.vue?vue&type=style&index=0&id=3ea3ef31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3ef31",
  null
  
)

export default component.exports